import React from 'react';
import DelaysBreakdown, { DelayReason } from './DelaysBreakdown';

interface PacuDelaysBreakdownProps {
  reasons: DelayReason[];
}

const PacuDelaysBreakdown = (props: PacuDelaysBreakdownProps) => {
  return <DelaysBreakdown reasons={props.reasons} />;
};

export default PacuDelaysBreakdown;
